<template>
	<div class="type-select__container">
		<Select
			:id="`${column.name}-type`"
			v-model="column.type"
			class="type-select__select"
			filter
			option-group-children="items"
			option-group-label="label"
			scroll-height="300px"
			:options="typeOptions">
			<template #value>
				<div class="type-select__value">
					<i
						class="type-select__value-icon"
						:class="`fal ${iconMap[column.type]}`"></i>
					<div class="type-select__value-name">
						{{ camelCaseToLabel(column.type) }}
					</div>
				</div>
			</template>
			<template #option="slotProps">
				<FontAwesomeIcon :icon="'fal ' + iconMap[slotProps.option as keyof typeof iconMap]" />
				<div style="margin-left: 10px">
					{{ camelCaseToLabel(slotProps.option) }}
				</div>
			</template>
		</Select>
	</div>
</template>

<script setup lang="ts">
import Select from 'primevue/select'
import { camelCaseToLabel } from '@codecannon/schemas/utils/strings'
import { iconMap } from '@codecannon/schemas/helpers/typeMap'
import type { EnrichedColumn } from '@codecannon/schemas/schemas/EnrichedColumn'
import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue'

defineProps<{
	column: EnrichedColumn
}>()

const typeOptions: { label: string; items: (keyof typeof iconMap)[] }[] = [
	{
		label: 'Common',
		items: ['string', 'text', 'integer', 'decimal', 'boolean', 'dateTime', 'enum'],
	},
	{
		label: 'Text',
		items: ['char', 'tinyText', 'mediumText', 'longText'],
	},
	{
		label: 'Numeric',
		items: ['double', 'float', 'tinyInteger', 'smallInteger', 'mediumInteger', 'bigInteger'],
	},
	{
		label: 'Date & Time',
		items: ['date', 'time', 'timestamp', 'year'],
	},
	{
		label: 'Misc',
		items: ['binary', 'foreignId', 'uuid'],
	},
]
</script>

<style lang="scss" scoped>
.type-select__container {
	display: flex;
	flex-direction: column;
	gap: 10px;

	.type-select__select {
		:deep(.p-select-dropdown) {
			display: none;
		}

		.type-select__value {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 70px;
			height: 70px;

			.type-select__value-icon {
				font-size: 28px;
				color: var(--p-primary-500);
			}

			.type-select__value-name {
				width: 100%;
				text-wrap: wrap;
				text-align: center;
				font-size: 12px;
			}
		}
	}
}
</style>
